module.exports = __webpack_public_path__ + "static/media/package.f5e3a599.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/badges/package.svg
 ** module id = 444
 ** module chunks = 0
 **/